import React from 'react'
import DynamicColor from './dynamic-color'
import { COLOR_NAME } from '../../constants'
import { useTranslation } from 'react-i18next'

const DataNotFound = () => {
    const { t } = useTranslation()

    return (
        <DynamicColor
            style={{ color: COLOR_NAME.BODY_TEXT }}
            className="container flex-1 d-flex xy-center flex-column"
        >
            <DynamicColor
                style={{ color: COLOR_NAME.BODY_ICON }}
                tag="i"
                className="fas fa-3x fa-utensils"
            />

            <div className="mt-4 label-1">{t('message.dataNotFound')}</div>
        </DynamicColor>
    )
}

export default DataNotFound
